import { useState, useCallback, useEffect } from "react";
import { AdminData } from "@/interfaces";
import { IsAdminModeContextProps } from "./context";

const ADMIN_MODE_KEY = "isAdminMode";
const ADMIN_DATA_KEY = "currentAdminData";

export const useIsAdminModeContextController = (): IsAdminModeContextProps => {
  // Initialize from localStorage
  const [isAdminModeValue, setIsAdminModeValue] = useState<boolean>(() => {
    const stored = localStorage.getItem(ADMIN_MODE_KEY);
    return stored === "true";
  });
  
  const [currentAdminDataValue, setCurrentAdminDataValue] = useState<
    AdminData | undefined
  >(() => {
    const stored = localStorage.getItem(ADMIN_DATA_KEY);
    return stored ? JSON.parse(stored) : undefined;
  });

  const setIsAdminMode = useCallback(
    (isAdminMode: boolean) => {
      setIsAdminModeValue(isAdminMode);
      localStorage.setItem(ADMIN_MODE_KEY, String(isAdminMode));
      
      // Clear admin data when logging out
      if (!isAdminMode) {
        localStorage.removeItem(ADMIN_DATA_KEY);
        setCurrentAdminDataValue(undefined);
      }
    },
    [setIsAdminModeValue]
  );

  const setCurrentAdminData = useCallback(
    (adminData?: AdminData) => {
      setCurrentAdminDataValue(adminData);
      if (adminData) {
        localStorage.setItem(ADMIN_DATA_KEY, JSON.stringify(adminData));
      } else {
        localStorage.removeItem(ADMIN_DATA_KEY);
      }
    },
    [setCurrentAdminDataValue]
  );

  return {
    isAdminMode: isAdminModeValue,
    setIsAdminMode,
    currentAdminData: currentAdminDataValue,
    setCurrentAdminData,
  };
};
